import { render } from "./bundleDetailModal.vue?vue&type=template&id=877d21a0"
import script from "./bundleDetailModal.vue?vue&type=script&lang=js"
export * from "./bundleDetailModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__